<template>
  <div id="account-activation">
    <nav-bar-top icons-are-hidden is-primary />
    <div class="container has-nav-top-margin">
      <section
        v-if="isFetching"
        class="section has-text-centered"
      >
        <loading-spinner />
      </section>
      <section
        v-if="!isFetching && isAccountActivated"
        class="section"
      >
        <h4 v-if="!isErrorInActivation" class="title is-4">
          Your account has been activated!
        </h4>
      </section>
      <section
        v-if="!isFetching && isErrorInActivation"
        class="section"
      >
        <h4 class="title is-4">
          Uh oh! Looks like there was an error activating your account.
        </h4>
      </section>
      <section
        v-if="!isFetching"
        class="section no-pad-top"
      >
        <div v-if="isAccountActivated && !isErrorInActivation" class="log-in-form-container card card-content">
          <log-in-form
            v-if="!isForgotPasswordFormVisible"
            @togglePasswordResetForm="handleTogglePasswordResetForm"
          />
          <reset-password-form v-else @toggleLoginForm="toggleLoginForm($event)" />
        </div>
        <button
          v-if="isErrorInActivation"
          class="button is-rounded is-primary has-text-weight-bold"
        >
          Resend Activation Email
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import LoadingSpinner from '@/components/Utilities/LoadingSpinner';
import LogInForm from '@/components/Login/LogInForm';
import ResetPasswordForm from '@/components/Login/ResetPasswordForm';

export default {
  name: 'AccountActivation',
  components: {
    LoadingSpinner,
    NavBarTop,
    LogInForm,
    ResetPasswordForm
  },
  data () {
    return {
      isFetching: true,
      isAccountActivated: false,
      isErrorInActivation: false,
      token: null,
      isForgotPasswordFormVisible: false
    };
  },
  computed: {
    isUserCreatingProfile () {
      return this.$store.state.profileCreationCurrentStep !== null;
    }
  },
  created () {
    this.token = this.$route.params.id;
    this.$store.commit('LOG_OUT');
    this.$store.dispatch('activateUserAccount', { token: this.token })
      .then(response => {
        if (response.data.status === 'fail') {
          this.isFetching = false;
          this.isErrorInActivation = true;
        } else {
          this.$store.dispatch('initApp');
        }
      })
      .then(response => {
        this.isFetching = false;
        this.isAccountActivated = true;
      })
      .catch(error => {
        console.log('Error Activating Account', error);
        this.isFetching = false;
        this.isErrorInActivation = true;
      });
  },
  methods: {
    handleTogglePasswordResetForm () {
      this.isForgotPasswordFormVisible = true;
    },
    toggleLoginForm ($event) {
      this.isForgotPasswordFormVisible = !$event;
    }
  }
};
</script>

<style lang="scss" scoped>
.log-in-form-container {
  max-width: 400px;
  margin: 0 auto;
}
</style>
